import { render, staticRenderFns } from "./SendSingleRemitterEmail.vue?vue&type=template&id=dc2cff48"
import script from "./SendSingleRemitterEmail.vue?vue&type=script&lang=js"
export * from "./SendSingleRemitterEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports